<template>
  <main>
    <pageInnerHeaderComponent :lang="lang" :title="'pages.references'"></pageInnerHeaderComponent>
    <referencesComponent :lang="lang" :title="'pages.references'"></referencesComponent>
    <recommendationComponent :lang="lang" :title="'pages.references.recommendations'"></recommendationComponent>
    <!-- <imageTextComponent :lang="lang" :title="'pages.references'" /> -->
  </main>
</template>
<script>
import recommendationComponent from "@/components/recommendation/recommendation.vue";
// import imageTextComponent from "@/components/imageText/imageText.vue";
import referencesComponent from "@/components/references/references.vue";
import pageInnerHeaderComponent from "@/components/pageInnerHeader/pageInnerHeader.vue";
import tr from "@/lang/tr.js";
import en from "@/lang/en.js";
export default {
  mixins: [tr, en],
  name: "ReferencesView",
  metaInfo() {
    return {
      title: this.metaTitle
        ? this.metaTitle
        : "KOBİSİ HIZLI E-TİCARET PLATFORMU",
      meta: [
        {
          name: "description",
          content: this.metaDescription ? this.metaDescription : "",
        },
        {
          property: "og:title",
          content: this.metaTitle ? this.metaTitle : "KOBİSİ HIZLI E-TİCARET PLATFORMU",
        },
        { name: "robots", content: "index,follow" },
        { property: "og:type", content: "" },
        { property: "og:title", content: " Neden Kobisi'yi tercih etmeliyim?" },
        { property: "og:description", content: "Kullanım kolaylığı, güvenlik ve hız, müşterilerimizin e-ticaret sitelerini açmak için Kobisi’yi tercih etmelerinin altında yatan nedenlerden sadece birkaçı." },
        { property: "og:image", content: "" },
        { property: "og:url", content: "kobisi.com/referanslar" },
        { property: "og:site_name", content: "Kobisi" },
      ],
    };
  },
  components: {
    referencesComponent,
    recommendationComponent,
    // imageTextComponent,
    pageInnerHeaderComponent
  },
  data() {
    return {
      metaDescription: null,
      metaTitle: null,
    };
  },
  props: {
    lang: String,
    title: String,
  },
  mounted() {
    document.body.classList.add("references", "active-page");
    this.metaTitle = this[this.lang].pages.references.metaTags.title;
    this.metaDescription = this[this.lang].pages.references.metaTags.description;


    // let a = this[this.lang].pages.references.metaTags.title;

    // window.addEventListener("blur", function () {
    //   document.title = "bizi unutmayın"
    // });

    // window.addEventListener("focus", function () {
    //   document.title = a
    // });


  },
  destroyed() {
    document.body.classList.remove("references", "active-page");
    
  },
};
</script>
<style lang="scss" scoped>

</style>
